import { actionTypes } from '../common/constants/actionTypes';

import BreadcrumbItem from '../api/breadcrumbItem';
import BreadcrumbsPath from '../api/breadcrumbsPathEntity';

export const breadcrumbItemsReducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.BREADCRUMB_CHANGED_ON_NEWS_PAGE:
      return handleBreadcrumbChangedOnNewsPage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE:
      return handleBreadcrumbChangedOnArchivePage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_NEWS_LIST_PAGE:
      return handleBreadcrumbChangedOnNewsListPage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_PAGE:
      return handleBreadcrumbChangedOnCertificatesPage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE:
      if (action.payload instanceof BreadcrumbsPath) {
        return handleBreadcrumbChangedOnContentSubPage(state, action.payload);
      }
      return handleBreadcrumbChangedOnContentPage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_COMPETENCES_PAGE:
      return handleBreadcrumbChangedOnCompetencesPage(state, action.payload);

    case actionTypes.BREADCRUMB_CHANGED_ON_COMPETENCES_CONTENT_PAGE:
      if (action.payload instanceof BreadcrumbsPath) {
        return handleBreadcrumbChangedOnContentSubPage(state, action.payload);
      }
      return handleBreadcrumbChangedOnContentPage(state, action.payload);

    case actionTypes.SET_TOP_NAVIGATION_ACTIVE_CSS:
      return handleSetTopNavigationActiveCss(state, action.payload);
  }

  // initial state
  if (state) {
    return state;
  }
  return {
    breadcrumbItems: [],
    latestPageTitle: '',
    nextRouteLocationPathname: ''
  };
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const BASE_BREADCRUMB = { id: 1, title: 'Etusivu', navigationUrl: '/' };

const handleSetTopNavigationActiveCss = (state: any, path: string) => ({
  breadcrumbItems: state.breadcrumbItems,
  latestPageTitle: state.latestPageTitle,
  nextRouteLocationPathname: path,
});

const handleBreadcrumbChangedOnNewsPage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB, { id: 2, title: 'Ajankohtaista', navigationUrl: '/ajankohtaista' }],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnArchivePage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnNewsListPage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnCertificatesPage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnCompetencesPage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnContentPage = (state: any, payload: BreadcrumbItem) => ({
  breadcrumbItems: [BASE_BREADCRUMB],
  latestPageTitle: payload,
  nextRouteLocationPathname: state.nextRouteLocationPathname,
});

const handleBreadcrumbChangedOnContentSubPage = (state: any, payload: BreadcrumbsPath) => {
  const result = {
    breadcrumbItems: [BASE_BREADCRUMB],
    latestPageTitle: payload.latestPageTitle,
    nextRouteLocationPathname: state.nextRouteLocationPathname,
  } as { breadcrumbItems: any[]; latestPageTitle: string; nextRouteLocationPathname: string };

  if (payload.id !== '') {
    buildBreadcrumbPath(result, payload, 2);
  }
  return result;
};

function buildBreadcrumbPath(
  result: { breadcrumbItems: any[] },
  node: BreadcrumbsPath,
  id: number,
) {
  result.breadcrumbItems.push({ id, title: node.title, navigationUrl: node.relativePath });
  if (node.parentBredcrumbsItem) {
    buildBreadcrumbPath(result, node.parentBredcrumbsItem, id + 1);
  }
}



// WEBPACK FOOTER //
// ./src/reducers/breadcrumb.ts